module.exports = __webpack_public_path__ + "static/media/correct-answer.ee6aadae.mp3";